/* eslint-disable */
export const colors = {
    // primary: "#3790ff",
    primary: "#0168EA",
    primaryLight: "rgb(216, 235, 255)",
    secondary: "#3a96fb",
    lightGray: "#a4a4a4",
    lightLightGray: "#EEEEEE",
    gray: "#757575",
    darkGray: "#363636",
    success: "#72C072",
    successBackground: "#72C07229",
    logoBlue: "#004370",
    white: "#ffffff",
    warning: "orange",
    warningBackground: "#ffa50029",
    error: "#e91e63",
    errorBackground: "#e91e631a",
    created: "#3092e3",
    lightGreen: "rgb(3, 224, 0)",
    green: "green",
    red: "red",
    lightBlue: "rgb(100, 174, 224)",
    lightYellow: "#FEF9D3",
    lightViolette: "#E3D8E9",
    lightRose: "#F4C1B9",
    lightPale: "#87C09B",
    slightBlue: "#4fa7f0",
  };
  export const entities = {
    insurance: "#7b1fa2",
    unknownInsurance: "#e91e63",
  };